import useSWR from 'swr';
import { analyticsService, TechniciansResponse } from '../services/analyticsService';

interface UseAnalyticsTechniciansReturn {
  technicians: TechniciansResponse | undefined;
  loading: boolean;
  error: Error | undefined;
}

export const useAnalyticsTechnicians = (year: number): UseAnalyticsTechniciansReturn => {
  const { data, error, isLoading } = useSWR<TechniciansResponse, Error>(
    `/api/v1/analytics/service/technicians?year=${year}`,
    () => analyticsService.getTechnicians(year),
    {
      revalidateOnFocus: false,
      revalidateOnReconnect: true,
      dedupingInterval: 5000,
    }
  );

  return {
    technicians: data,
    loading: isLoading,
    error,
  };
};
